// PaymentsButtons.js
import React from "react";
import { Row, Col, Button } from "react-bootstrap";
import { PayPalButtons, usePayPalScriptReducer } from "@paypal/react-paypal-js";
import { useTranslation } from "react-i18next";

function PaymentButtons({
  totalPriceWithShippingCost,
  handleCheckout,
  handleKlarnaPayment,
  isPaymentSuccess,
  handleError,
}) {
  const { t } = useTranslation();
  const [{ isPending, isResolved, isRejected }] = usePayPalScriptReducer();

  if (isPaymentSuccess) return null;

  return (
    <Row className="mt-4">
      <Col md={6}>
        <div id="paypal-button-container">
          {isPending && <div>{t("loading_paypal_button")}</div>}

          {isResolved && (
            <PayPalButtons
              style={{
                shape: "rect",
                color: "gold",
                layout: "horizontal",
                label: "pay",
                tagline: false,
              }}
              createOrder={(data, actions) => {
                const totalPriceRounded = totalPriceWithShippingCost.toFixed(2);
                return actions.order.create({
                  purchase_units: [
                    {
                      amount: {
                        value: totalPriceRounded,
                      },
                    },
                  ],
                });
              }}
              onApprove={async (data, actions) => {
                return actions.order.capture().then(async () => {
                  await handleCheckout();
                });
              }}
              onError={handleError}
            />
          )}

          {isRejected && (
            <div className="text-danger">
              {t("paypal_sdk_failed")}
            </div>
          )}
        </div>
      </Col>

      <Col md={6}>
        <div id="klarna-button-container">
          <Button
            variant="outline-dark"
            className="w-100"
            onClick={handleKlarnaPayment}
          >
            {t("pay_with_klarna")}
          </Button>
        </div>
      </Col>
    </Row>
  );
}

export default PaymentButtons;
